
import lottie from 'vue-lottie/src/lottie.vue';
import * as animationData from 'static/DC-spinner-functions.json';
import * as whiteAnimationData from 'static/DC-spinner-functions-white.json';

export default {
  name: 'LoadingSpinnerFunction',
  components: {
    lottie,
  },
  props: {
    playing: {
      type: Boolean,
      default: false,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    anim: null,
    lottieOptions: {
      animationData: animationData.default,
      autoplay: false,
    },
    whiteLottieOptions: {
      animationData: whiteAnimationData.default,
      autoplay: false,
    },
  }),
  watch: {
    playing() {
      if (this.playing) {
        this.anim.play();
      } else {
        this.anim.stop();
      }
    },
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
  },
};

